export enum ModalTitle {
  MakeAppointment = 'Записаться на прием',
  Confirmation = 'Подтверждение',
}
